import { render, staticRenderFns } from "./DodCustomInput.vue?vue&type=template&id=133abec8&scoped=true&"
import script from "./DodCustomInput.vue?vue&type=script&lang=js&"
export * from "./DodCustomInput.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomInput.vue?vue&type=style&index=0&id=133abec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133abec8",
  null
  
)

export default component.exports